import React from "react";
import map from "lodash/map";
import ProgramCardCP from "./ProgramCardCP";
import CycleCardCP from "./CycleCardCP";
import Pagination from "../../../../parts/pagination";

const ProgramsTemplates = ({ locals, cards, total, pageSize }) => {
  const { query, activeUserToRequest } = locals;

  const pageSizeConstant = 50;
  return (
    <section>
      <div className="columns">
        {query["program-view"] === "programs"
          ? map(cards, (program, cardIndex) => {
              return (
                <ProgramCardCP
                  key={program._id}
                  program={program}
                  cardIndex={cardIndex}
                />
              );
            })
          : map(cards, (cycle, cardIndex) => {
              return (
                <CycleCardCP
                  key={cycle._id}
                  cycle={cycle}
                  cardIndex={cardIndex}
                  isOwnCycle={cycle.owner === activeUserToRequest._id}
                />
              );
            })}
      </div>

      <Pagination total={total} pageSize={pageSize || pageSizeConstant} />

      <input
        type="radio"
        name="more"
        id="more-reset"
        style={{ display: "none" }}
      />
    </section>
  );
};

export default ProgramsTemplates;
